















































































































import Vue, { PropType } from 'vue'
import HiddenBox from '@/components/HiddenBox.vue'
import IListAction from '@/types/components/IListAction.interface'
import IListActionComponent from '@/components/IListAction.vue'
import IListIcon from '@/types/components/IListIcon.interface'
import IListIconComponent from '@/components/IListIcon.vue'
import IListTileColumn from '@/types/components/IListTileColumn.interface'
import Button from '@/types/components/Button.interface'
import InboxStatusSwitch from './InboxStatusSwitch.vue'
import inputsMixin from '@/mixins/inputs-mixin'
import Channel from '@/types/Channel.interface'
export default Vue.extend({
    components: {
        'hidden-box': HiddenBox,
        'i-list-action': IListActionComponent,
        'i-list-icon': IListIconComponent,
        'inbox-status-switch': InboxStatusSwitch
    },
    mixins: [inputsMixin],
    props: {
        //  The text displayed above the actionContent
        actionHeader: {
            type: String,
            default: null
        },
        //  The IListAction shown on the right side of the tile
        actionContent: {
            type: Object as PropType<IListAction>,
            default: null
        },
        //  The text displayed below the actionContent
        actionFooter: {
            type: String,
            default: null
        },
        //  The background color for our tile
        bgColor: {
            type: String,
            default: null
        },
        //  The handler for the tile click event
        callback: {
            type: Function,
            default: null
        },
        //  The columns for displaying on our tile
        columns: {
            type: Array as PropType<IListTileColumn[]>,
            default: null
        },
        //  Disables our IListTile from being selected
        disabled: {
            type: Boolean,
            default: false
        },
        hoverable: {
            type: Object,
            default: null,
            required: false
        },
        //  The item the tile is bound to
        item: {
            type: [Object, String],
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        leftHeader: {
            type: String,
            default: null
        },
        leftContent: {
            type: Object as PropType<IListAction>,
            default: null
        },
        leftIcon: {
            type: Object as PropType<IListIcon>,
            default: null
        },
        leftFooter: {
            type: String,
            default: null
        },
        //  Line (1) on the list tile
        line1: {
            type: String,
            default: null
        },
        //  Line (2) on the list tile
        line2: {
            type: String,
            default: null
        },
        //  Line (3) on the list tile
        line3: {
            type: String,
            default: null
        },
        //  Line (4) on the list tile
        line4: {
            type: String,
            default: null
        },
        //  A link displayed on the list tile
        link: {
            type: Object as PropType<Button>,
            default: null
        },
        //  Determines if a checkbox is shown in the tile, for multi-select feature
        multiSelect: {
            type: Boolean,
            default: false
        },
        //  Indicates the tile is multiSelected
        multiSelected: {
            type: Boolean,
            default: false
        },
        //  Determines if this tile is excluded from being multi-selected
        multiSelectHide: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: false
        },
        //  Indicates if the tile is selected
        selected: {
            type: Boolean,
            default: false
        },
        //  Color of the tile when selected
        selectedColor: {
            type: String,
            default: null
        },
        //  Condition that always shows the left side border
        sideBorderAlwaysPresent: {
            type: Boolean,
            default: null
        },
        //  Color for the left side border
        sideBorderColor: {
            type: String,
            default: null
        }
    },
    mounted() {
        //  We use a v-model on our checkbox to make it reactive to persisted state (bit hacky, but seems the only way to get checkbox to render correctly)
        this.multiSelectedValue = this.multiSelected
    },
    data: () => ({
        //  indicates if the conversations viewed are open or closed
        open: false,
        //  The v-model of our multi-select checkbox
        multiSelectedValue: false
    }),
    computed: {
        //  Determines if we display our right side action content
        actionContentVisible(): boolean {
            //  If we have no actions, return false
            if (!this.actionContent) return false

            //  If our action is NOT a menu, return true
            if (this.actionContent.type !== 'menu') return true

            //  Else, this is a menu so grab the menu
            const menu = this.actionContent.menu

            //  Filter out our items that cannot be viewed
            const filtered = menu.filter((x: Button) => this.isVisible(x))

            //  Value is based on whether our length is 0 or not
            return filtered.length > 0
        },
        //  Get the content style
        contentStyle() {
            //  Select the cursor we will display on hover (if there is a callback attached, use 'pointer')
            const cursor = this.callback ? 'pointer' : 'auto'

            //  Return the content style
            return { cursor: cursor }
        },
        //  Get the container style
        containerStyle() {
            //  Our default background color is the user set prop, or lighten6 if missing
            const defaultBg = this.bgColor || this.$colors.grey.lighten6

            //  Select background color.  We highlight multiselected or selected
            const bg =
                this.multiSelectedValue || (this.selectable && this.selected)
                    ? this.selectedColor
                    ? this.selectedColor
                    : this.$colors.grey.lighten4
                    : defaultBg

            //  Select the border color.  We accent multiselected or selected
            const c =
                this.multiSelected || (this.selectable && this.selected)
                    ? this.$colors.grey.lighten2
                    : this.$colors.grey.lighten3

            //  Return the container style
            return {
                backgroundColor: bg,
                borderColor: c
            }
        },
        //  Determine if the tile has a left-side IListAction
        hasLeftSide() {
            //  Check if any left-side content exists
            const hasLeftSide =
                this.leftHeader || this.leftContent || this.leftIcon || this.leftFooter

            //  Return the result
            return hasLeftSide
        }
    },
    methods: {
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        //  Determines if user is on mobile or not
        isMobile() {
            return this.$store.getters.isMobile()
        },
        //  Handle the tile click event
        onClick(item: any) {
            //  Check if the item is fake disabled
            const disabled = item.disabledPopup

            //  If it is, then pop our dialog
            if (disabled) return this.disabledPopup()

            //  If we're in multi-select mode...
            if (this.multiSelect) {
                //  Add the item to the multiSelected list
                this.onMultiSelectChanged(!this.multiSelectedValue, item)
            } else {
                //  Else, emit the item selected event
                this.$emit('itemSelected', item, this.callback)

                //  if the item has a callback, use it!
                if (this.callback) {
                    //  We use a timeout here is make sure the UI is released before continuing (much snappier UX!)
                    setTimeout(() => this.callback(item), 1)
                }
            }
        },
        //  Handle a toggle of the multiselect checkbox
        onMultiSelectChanged(bool: Boolean, item: any, hoverItem: Channel): void {
            this.$emit('itemMultiSelected', item, bool)
        }
    },
    watch: {
        multiSelected(val) {
            //  If the multi-select prop has changed, we need to update the checkbox's v-model
            this.multiSelectedValue = val
        }
    }
})
